import { PopupWithApiItem, toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { initiateBiosimilars } from "../../../api/postCall/initiateBiosimilars";
import { OncologySubmissionTableDataModel } from "../../../data-model/tablesData";
import { logError } from "../../../utils/customLogger";

interface OnBiosimilarRetryMarkSuccessParams {
  rowData: OncologySubmissionTableDataModel;
  popupItems: PopupWithApiItem[];
  checkedById: Record<string, boolean>;
  onSuccess: () => void;
  onClose: () => void;
}

/** Checkbox id for the biosimilar retry popup "Select All" row (not a drug option). */
export const BIOSIMILAR_SELECT_ALL_ITEM_ID = "biosimilar-select-all";

/**
 * Resolves selected biosimilar popup labels from checkbox state.
 *
 * @param popupItems - Popup checklist items for the row's biosimilar family
 * @param checkedById - Current checkbox selection keyed by item id
 * @returns Labels for checked biosimilar options
 */
export const getSelectedBiosimilarLabels = (
  popupItems: PopupWithApiItem[],
  checkedById: Record<string, boolean>,
): string[] =>
  popupItems
    .filter((item) => checkedById[item.id])
    .map((item) => item.label.trim())
    .filter(Boolean);

/**
 * Calls RPA initiate-biosimilars for the selected alternatives on the order row.
 *
 * @param params - Selected row, popup items, checkbox state, and success callback
 */
export const onBiosimilarRetryMarkSuccess = async ({
  rowData,
  popupItems,
  checkedById,
  onSuccess,
  onClose,
}: OnBiosimilarRetryMarkSuccessParams): Promise<void> => {
  const identifier = String(rowData.identifier ?? "").trim();
  if (!identifier) {
    toast.error("Order identifier is missing.");
    onClose();
    return;
  }

  const selectedLabels = getSelectedBiosimilarLabels(popupItems, checkedById);
  if (selectedLabels.length === 0) {
    toast.error("Select at least one biosimilar option.");
    return;
  }

 
  try {
    await initiateBiosimilars({
      parent_identifier: identifier,
      alternatives: selectedLabels,
      force: true,
    });
    toast.success("Biosimilar initiation started.");
    onSuccess();
  } catch (error) {
    logError(error as Error, "onBiosimilarRetryMarkSuccess");
    toast.error("Failed to initiate biosimilars. Please try again.");
  }
};
